import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { rutaInicial } from '../utils/menu';

export default function Login() {
  const { login }   = useAuth();
  const navigate    = useNavigate();
  const [form, setForm]     = useState({ username: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.username, form.password);
      // El destino depende de los permisos, no del rol: se entra en la
      // primera pantalla que la persona pueda ver.
      const puede = (codigo, accion = 'ver') =>
        !!(user.acceso_total || user.permisos?.[codigo]?.[accion]);
      navigate(rutaInicial(puede));
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #094d30 0%, #0d5d3a 60%, #1a8a58 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: '#fff', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)',
        width: '100%', maxWidth: '400px', overflow: 'hidden',
      }}>
        {/* Header verde con logo */}
        <div style={{
          background: 'var(--rg-green)', padding: '32px 32px 28px',
          textAlign: 'center',
        }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: 'rgba(255,255,255,.15)', margin: '0 auto 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: '2px solid rgba(255,255,255,.3)',
          }}>
            <span style={{ fontSize: 28, fontWeight: 900, color: '#fff', letterSpacing: -1 }}>RG</span>
          </div>
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 700, lineHeight: 1.3 }}>
            Autocares Rodríguez Gómez
          </div>
          <div style={{ color: 'rgba(255,255,255,.7)', fontSize: 13, marginTop: 4 }}>
            Panel de gestión
          </div>
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} style={{ padding: '28px 32px 32px' }}>
          {error && (
            <div className="alert alert-danger" style={{ marginBottom: 20 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <div className="form-group" style={{ marginBottom: 16 }}>
            <label className="form-label">Usuario</label>
            <input
              className="form-control"
              type="text"
              autoComplete="username"
              placeholder="Tu usuario"
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              required
              maxLength={60}
            />
          </div>

          <div className="form-group" style={{ marginBottom: 24 }}>
            <label className="form-label">Contraseña</label>
            <input
              className="form-control"
              type="password"
              autoComplete="current-password"
              placeholder="Tu contraseña"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required
              maxLength={128}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: '11px', fontSize: 15 }}
          >
            {loading ? <span className="spinner" style={{ width:18, height:18, borderWidth:2 }} /> : 'Entrar'}
          </button>
        </form>

        <div style={{
          textAlign: 'center', padding: '0 32px 20px',
          fontSize: 12, color: 'var(--rg-gray-400)',
        }}>
          © {new Date().getFullYear()} Autocares Rodríguez Gómez S.L.
        </div>
      </div>
    </div>
  );
}
